import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../services/authService";
import "./Login.css";

export default function Login() {

  const navigate = useNavigate();

  const [email, setEmail] = useState("");
  const [senha, setSenha] = useState("");
  const [erro, setErro] = useState("");

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      const data = await login(email, senha);

      if (data.token && data.siteId) {
        // Limpa antes de salvar para garantir que não haja lixo de sessões anteriores
        localStorage.clear(); 
        
        localStorage.setItem("token", data.token);
        localStorage.setItem("siteId", data.siteId);
        
        console.log("Login bem-sucedido. SiteID:", data.siteId);
        navigate("/");
      } else {
        setErro("Erro ao recuperar dados do servidor.");
      }
    } catch (err) {
      setErro(err.message);
    }
  }

  return (

    <div className="login-container">

      <form className="login-card" onSubmit={handleSubmit}>

        <h1>Percept Transparência</h1>

        <p>Faça login para continuar</p>

        {erro && (
          <div className="login-error">
            {erro}
          </div>
        )}

        <input
          type="email"
          placeholder="Seu email"
          value={email}
          onChange={(e)=>setEmail(e.target.value)}
          required
        />

        <input
          type="password"
          placeholder="Sua senha"
          value={senha}
          onChange={(e)=>setSenha(e.target.value)}
          required
        />

        <button type="submit">
          Entrar
        </button>

      </form>

    </div>

  );
}